module.exports = __webpack_public_path__ + "img/CloseMed.f2a9f533.svg";